<template>
    <v-flex>
        <v-layout row class="content-header">
            <v-flex md12 class="content-title">
                <h2>Comissionamento em Aberto</h2>
                <h4>Apresenta a posição da conta corrente de comissões de agenciamento/corretagem em aberto.</h4>
            </v-flex>
            <v-flex md12>
                <br>
                <div class="line"></div>
            </v-flex>
        </v-layout>
        <v-layout row class="content-body overflow-y-auto">
            <v-flex md12>
                <v-data-table
                    :headers="headers"
                    :items="comissoesPendentes"
                    :items-per-page="topItems"
                    :loading="loading"
                    loading-text="Carregando... Por favor aguarde."
                    :sort-by="['dataEtl']"
                    no-data-text="Nenhuma informação encontrada"
                    no-results-text="Nenhuma informação encontrada"                    
                    :sort-desc="[true]"                         
                    class="">
                    <template v-slot:item.tipoComissao="{ item }">
                        {{ tipoComissao(item.tipoComissao) }}
                    </template>
                    <template v-slot:item.comissaoCalcula="{ item }">
                        {{ formatPrice(item.comissaoCalcula) }}
                    </template>
                    <template v-slot:item.dataEtl="{ item }">
                        {{ item.dataEtl | formatDateBR }}
                    </template>
                    <template v-slot:item.excel="{ item }">
                        <img class="hover" src="/img/icon-xls.png" @click="gerarExcel(item)" />
                    </template>
                    <template v-slot:item.pdf="{ item }">
                        <img class="hover" src="/img/icon-pdf.png" @click="gerarPDF(item)" />
                    </template>
                </v-data-table>
            </v-flex>

            <v-overlay :value="fullLoading">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

        </v-layout>
    </v-flex>
</template>

<script>

    import Vue from 'vue';
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";
    import moment from 'moment';
    
    export default {
        mixins: [Helpers],
        data() {
            return {
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                termoPesquisa: "",
                loading: true,
                fullLoading: false,
                topItems: 10,
                totalItems: 100,
                offset: 1,
                headers: [
                    {text: "Tipo", value: "tipoComissao", sortable: true },
                    {text: "Valor (R$)", value: "comissaoCalcula", sortable: true },
                    {text: "Dados Atualizados Em.:", value: "dataEtl", sortable: true },
                    {text: "Download (Excel)", value: "excel", sortable: false},
                    {text: "Download (PDF)", value: "pdf", sortable: false}
                ],
                comissoesPendentes: []
            }
        },        
        methods: {
            requestComissoes(){
                this.loading = true;
                this.fullLoading = true;

                let codigoCorretor = this.usuario.codCorretor;                

                let url = "ComissaoPendente/"+codigoCorretor;
                 
                 // Se tiver termo para pesquisa
                if(this.termoPesquisa != "")
                    url += "?$filter=NumeroApolice eq '" + this.termoPesquisa + "'";
                    //console.log(url)


                // Request comissoes
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.comissoesPendentes = res.data;
                    this.loading = false;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.loading = false;
                    this.fullLoading = false;
                });        
            },
            gerarExcel(value){
                let tipoComissao = value.tipoComissao;
                let url = this.baseURL + "Emissao/CorretagemExcel/"+this.usuario.codCorretor+"/"+tipoComissao;
                window.open(url, "_blank");
            },
            gerarPDF(value){
                let tipoComissao = value.tipoComissao;
                let url = this.baseURL + "Emissao/CorretagemPdf/"+this.usuario.codCorretor+"/"+tipoComissao;
                
                window.open(url, "_blank");
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            tipoComissao(value){
                if(value == "COR")
                    return "Corretagem";
                if(value == "PRO")
                    return "Pró-Labore";
                if(value == "AGE")
                    return "Agenciamento";

                return value;
            }
        },      
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUserInfo" })
        },
        filters: {
            formatDateBR(value) {
                if (value) {
                    return moment(String(value)).format('DD/MM/YYYY hh:mm');
                }
            },
        },
        mounted(){            
            this.requestComissoes()
        },
    }
</script>
